// extracted by mini-css-extract-plugin
module.exports = {"CoverImage":"CoverImage-module--CoverImage--KpzoR","CoverImage_Ghost":"CoverImage-module--CoverImage_Ghost--1BFS8"};